import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, ViewController, NavParams } from 'ionic-angular';

import { Master  } from '@providers/asset/index';

@Component({
  selector: 'page-project',
  templateUrl: 'page.html'
})
export class ProjectPage {

  List: any = [];
  pilihModal=0;
  keyword='';

  constructor(
    public navCtrl: NavController,
    public masterApi: Master,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public viewCtrl: ViewController,
    public navParams: NavParams
  ) {
    this.pilihModal = navParams.get('pilih');
  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(keyword=''){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params:any = { };
    if(keyword!=''){
      params.keyword=keyword;
    }

    this.masterApi.getProject(params).subscribe((resp:any) => {
      this.List = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  select(item){
    let data = { item: item };
    if(this.pilihModal==1){
      this.viewCtrl.dismiss(data);
      console.log(data.item.project_code, data.item.title);
    }
  }

  onInput(e){
    this.getList(this.keyword);
  }

  onCancel(e){
    this.getList();
  }

  closeModal(){
    let data = {item:''};
    this.viewCtrl.dismiss(data);
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/project/page.ts